module.exports = __webpack_public_path__ + "img/banner.21e4c13f.png";